import { render, staticRenderFns } from "./Manter.vue?vue&type=template&id=b1e68930"
import script from "./Manter.vue?vue&type=script&lang=ts"
export * from "./Manter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports